import { message } from 'antd';
import { accAdd, accSub } from '../../util/math';
import { PLAN_LIST_ADD_PRODUCT, PLAN_LIST_REDUCE_PRODUCT, PLAN_LIST_REMOVE_PRODUCT, PLAN_LIST_CLEAR_PRODUCT, PLAN_LIST_MODIFY_PRODUCT, RESTORE_PLAN_LIST, } from '../constants';
import { requestCartInfo, requestAddProduct, requestModifyProduct, requestRemoveProduct, } from '../request';

const type = 2;

export function planListAddProduct(product, count = 1, showMessage = true) {
  return function (dispatch, getState) {
    const state = getState();
    const {
      planList: { products },
    } = state;
    const productInfo = products[product.normsId];
    let num = count;
    if (productInfo) {
      num = accAdd(productInfo.num, count);
    }
    requestAddProduct(product.id, num, product.unit, type).then(res => {
      if (res.data.code === 0) {
        showMessage && message.success('成功加入计划清单!', 1);
        dispatch({
          type: PLAN_LIST_ADD_PRODUCT,
          product,
          count
        });
      }
    });
  };
}
export function planListReduceProduct(normsId) {
  return function (dispatch, getState) {
    const state = getState();
    const { planList: { products }, } = state;
    const product = products[normsId];
    const product_mixins_number = accSub(product.num, 1);
    if (product && product_mixins_number >= 0) {
      requestModifyProduct(product.cartId, product_mixins_number, type);
    }
    dispatch({
      type: PLAN_LIST_REDUCE_PRODUCT,
      product,
    });
  };
}
export function planListRemoveProduct(normsId, cartId) {
  return function (dispatch) {
    requestRemoveProduct(Array.isArray(cartId) ? cartId : [cartId], type);
    dispatch({
      type: PLAN_LIST_REMOVE_PRODUCT,
      normsId,
    });
  };
}
export function planListClearProduct() {
  return function (dispatch, getState) {
    const state = getState();
    const { planList: { cartIds }, } = state;
    requestRemoveProduct(cartIds, type);
    dispatch({
      type: PLAN_LIST_CLEAR_PRODUCT,
    });
  };
}
export function planListModifyProduct(product, num) {
  return function (dispatch) {
    requestModifyProduct(product.cartId, num, type);
    dispatch({
      type: PLAN_LIST_MODIFY_PRODUCT,
      product,
      num,
    });
  };
}
export function initPlanList() {
  return function (dispatch) {
    requestCartInfo((products) => {
      dispatch({
        type: RESTORE_PLAN_LIST,
        products: products.map(item => ({ ...item, number: +item.number, num: +item.num })),
      });
    }, type);
  };
}
